import { createContext, useContext } from "react";

// §11/D65 — stellt dem kind-Fallback-Renderer (und Tool-ResultRenderern, die ihn nutzen) die
// kurzlebigen presigned-GET-`downloadUrl`s je Asset-ID bereit, OHNE die `ResultRendererProps`-
// Signatur (`assets: AssetRef[]`, Contract §3.4) zu ändern. Fehlt eine URL (kein r2_key /
// keine R2-Creds), greift weiter die Platzhalter-Kachel (D43). React-Context fließt durch die
// Tool-Renderer hindurch, sodass die Verdrahtung an EINER Stelle (FallbackRenderer) genügt.

const ResultUrlContext = createContext<Record<string, string>>({});

export const ResultUrlProvider = ResultUrlContext.Provider;

/** Presigned-Download-URL eines Asset (oder undefined → Platzhalter). */
export function useResultUrl(assetId: string): string | undefined {
  return useContext(ResultUrlContext)[assetId];
}
